import { ArrowBigRight } from "lucide-react";
import { Link } from "react-router-dom";
import { formatDateTime } from "../utils/formatters";
import { LogRequest } from "../types/logs/request.type";

interface TableTransformerOptions {
  basePath?: string;
}

const sanitizeBasePath = (basePath?: string) => {
  if (!basePath) return "";

  return basePath.endsWith("/") ? basePath.slice(0, -1) : basePath;
};

export class LogRequestsTransformer {
  static tableTransformer({ basePath }: TableTransformerOptions = {}) {
    const sanitizedBasePath = sanitizeBasePath(basePath);

    return (logRequests: LogRequest[]) => {
      return logRequests.map((log) => {
        const linkTo = sanitizedBasePath ? `${sanitizedBasePath}/${log.id}` : log.id;

        return {
          ...log,
          created_at: formatDateTime(new Date(log.created_at)),
          operation_description: log.operation_description,
          success: log.success ? 'Sucesso' : 'Falha',
          actions: (
            <Link to={linkTo}>
              <ArrowBigRight />
            </Link>
          )
        };
      });
    };
  }
}
